var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotSuitableForEvents = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeWidth: 1.25,
  clipPath: "url(#notSuitableForEvents_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19.338 18.158c.897-.897.17-3.078-1.624-4.872s-3.976-2.521-4.873-1.624-.17 3.078 1.624 4.872 3.976 2.521 4.873 1.624"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m12.475 12.488-5.698 9.994a1.313 1.313 0 0 0 1.743 1.742l9.993-5.694M17.25 4.656a12.1 12.1 0 0 1-.465 4.918M20.498 5.861l-.464 2.32M26.343 13.75a12.1 12.1 0 0 0-4.917.465M25.138 10.502l-2.32.464"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.073 8.51a.328.328 0 0 1 0-.656M13.073 8.51a.328.328 0 1 0 0-.656M19.57 11.295a.328.328 0 1 1 0-.656M19.57 11.295a.328.328 0 1 0 0-.656M23.282 7.582a.328.328 0 1 1 0-.656M23.282 7.582a.328.328 0 1 0 0-.656M23.282 16.863a.328.328 0 1 1 0-.656M23.282 16.863a.328.328 0 1 0 0-.656"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  clipPath: "url(#notSuitableForEvents_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.935 15a14.062 14.062 0 1 0 28.125 0A14.062 14.062 0 0 0 .935 15M5.054 24.944 24.94 5.057"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "notSuitableForEvents_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6 4h21v21H6z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "notSuitableForEvents_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})))));
export default SvgNotSuitableForEvents;